<template>
  <div class="nc-text tw-flex tw-h-full tw-flex-col">
    <div v-if="label" class="tw-mb-1">
      <lazy-library-text :text="label" tag="span" type="input-label"></lazy-library-text>
      <span v-if="isRequired" style="color: #ff0000; font-size: 14px">*</span>
    </div>
    <div class="n-select">
      <select
        v-model="childModelValue"
        :name="name"
        class="n-select-box tw-w-full tw-p-3"
        :class="selectInputClasses"
        style="height: 60px; background: var(--c-input)"
      >
        <option
          v-for="(option, index) in optionsWithPleaseSelect"
          :key="`${key}-${index}`"
          :value="option[valueField]"
          :disabled="option.isDisabledOption"
        >
          {{ option[labelField] }}
        </option>
      </select>
    </div>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { mapState } from 'pinia';
import { produceKey } from '~/server/core/helpers';
import { useWebsiteStore } from '~/units/website/store';

export default defineNuxtComponent({
  name: 'NcSelect',

  props: {
    modelValue: {
      required: true,
    },

    label: {
      required: false,
      type: String,
      default: null,
    },

    name: {
      required: false,
      type: String,
      default: null,
    },

    options: {
      required: true,
      type: Array as PropType<any[]>,
    },

    valueField: {
      required: false,
      type: String,
      default: 'value',
    },

    labelField: {
      required: false,
      type: String,
      default: 'title',
    },

    isRequired: {
      required: false,
      type: Boolean,
      default: false,
    },

    isPleaseSelectActive: {
      required: false,
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      key: produceKey(),
    };
  },

  emits: ['update:modelValue'],

  computed: {
    ...mapState(useWebsiteStore, ['theme']),

    optionsWithPleaseSelect() {
      const options = [];

      if (this.isPleaseSelectActive) {
        options.push({
          [this.valueField]: undefined,
          [this.labelField]: 'Please select',
          isDisabledOption: true,
        });
      }

      return [...options, ...this.options];
    },

    childModelValue: {
      get() {
        return this.modelValue;
      },
      set(value: string) {
        this.$emit('update:modelValue', value);
      },
    },

    selectInputClasses() {
      switch (this.theme) {
        case 'theme3':
          return 'tw-border tw-border-[#DDDDDD]';
        default:
          return '';
      }
    },
  },
});
</script>

<style scoped>
.n-input {
  font-weight: 100;
  font-size: 16px;
  border: 1px solid #aca39a;
}

.n-input input {
  border: none !important;
  padding-left: 16px;
}

.n-input input::placeholder {
  color: var(--input--placeholder);
  font-weight: 100 !important;
}
</style>
